
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Goatopunecabs() {



    const cardData =
    {
        keyword: 'Goa to Pune Cabs',
        heading: 'Meghana Cab : Goa to Pune Cabs',
        headingDescription: 'Meghana Cab offers Goa to Pune Cab services, providing a smooth, safe, and comfortable return journey from the coastal beauty of Goa to the vibrant city of Pune. Whether you’re returning after a beach vacation, business trip, or family outing, our professional drivers ensure a relaxed and timely travel experience. Covering approximately 450 kilometers, the route offers scenic views through the Western Ghats, made even more enjoyable in our clean and air-conditioned sedans, SUVs, and tempo travellers. With 24/7 customer assistance, transparent pricing, and on-time pickups, Meghana Cab guarantees a convenient and hassle-free travel experience. Book your Goa to Pune Cab with Meghana Cab for a reliable and affordable interstate ride.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic palace-fort in the heart of Pune, originally built in 1730 AD by the Peshwas. Its grand gates, ornate balconies, and spacious courtyards reflect the glory of Maratha architecture. Though much was destroyed by fire, the remaining ruins echo tales of intrigue, power, and royal life. Evening light-and-sound shows narrate its history, drawing locals and tourists alike. The gardens and pathways are perfect for leisurely strolls. Close to Dagdusheth Ganapati, it anchors the city’s old-town heritage precinct."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a serene, sprawling memorial where Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters were interned during India’s Quit India Movement. Its graceful domes, imposing pillars, and lush gardens offer a peaceful retreat. The small museum inside displays letters, photographs, and personal items of Gandhi, making it both spiritual and educational. The garden's paths and fountains invite reflective walks. It also symbolizes Pune’s role in India’s struggle for independence."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Embedded in the city’s core, Pataleshwar is an 8th-century rock-cut cave temple first carved during the Rashtrakuta era. Though modest in scale, its monolithic excavation, pillared hall, and Nandi shrine convey an aura of ancient artistry and devotion. It’s surprising to find such calm in bustling Pune. The surrounding garden and shaded areas make it a quiet retreat. Photography is limited inside, ensuring the sanctity of this sacred site. A visit here connects city walkers to Pune’s hidden historic soul."
  },
  {
    "title": "Pune-Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Also called the Pu La Deshpande Udyan, this garden is Pune’s Japanese-style oasis inspired by Okayama’s Koraku-en Garden. Spread across 10 acres, the garden features meandering walkways, gently flowing water canals, stone bridges, koi ponds, and manicured landscaping. It’s an ideal spot for morning walks, poetry reading, or quiet meditation. The balance of water, stone, and green spaces makes it especially soothing during monsoons. Locals often visit for picnics and family time."
  },
  {
    "title": "ISKCON NVCC Temple",
    "description": "ISKCON NVCC (New Vedic Cultural Center) is a beautiful temple complex located in Kondhwa, Pune, dedicated to Radha-Krishna and Venkateswara (Balaji). Built with red sandstone, marble, and intricate carvings, its architecture blends North and South styles. The temple hosts daily kirtans, Gita classes, and spiritual discourses. The sacred ambiance, pristine gardens, and calm prayer halls invite visitors seeking peace and devotion. It’s also a spiritual landmark amidst Pune’s urban sprawl."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched about 25 km southwest of Pune, Sinhagad is a legendary hill fort with dramatic views over the surrounding valleys. The trek to the fort is famed—especially during monsoon—through lush greenery and rugged terrain. At the top, ruins of bastions, gates, and water tanks await exploration. The fort witnessed heroic battles (e.g. Tanaji’s sacrifice) and still resonates with tales of Maratha valor. Early morning visits reward you with sunrise, fresh mountain air, and quiet reflections far from the city bustle."
  },
  {
    "title": "Karla and Bhaja Caves",
    "description": "On the outskirts of Pune lie the ancient Buddhist rock-cut caves of Karla and Bhaja, dating back over 2,000 years. Karla has one of India’s largest chaityas (prayer halls), while Bhaja features intricate carvings, stupas, and dancing figures. The approach involves a short nature walk, passing scenic hills and greenery. The caves reflect India’s early Buddhist heritage and artistic brilliance. They’re ideal for history buffs, spiritual seekers, and nature lovers alike—blending culture with tranquility."
  },
  {
    "title": "Tikona Fort",
    "description": "Situated about 60 km from Pune in Maval, Tikona Fort (also called Vitandgad) is a pyramidal hill fort ideal for trekking and panoramic views. The ascent leads you past seven natural water tanks, remains of old stone gates, and ASI-protected ruins. At the top, you get sweeping vistas of Pawna reservoir, nearby forts like Lohagad and Visapur, and rolling hills. It’s a moderately challenging but rewarding hike, especially enjoyed during monsoon when the hills are lush and misty."
  },
  {
    "title": "Bal Gandharva Ranga Mandir",
    "description": "Bal Gandharva Ranga Mandir is a prominent cultural theatre in Shivajinagar, Pune, named after the famous Marathi singer-actor Bal Gandharva. With a seating capacity of nearly 1,000, it hosts regular Marathi and Hindi plays, musicals, exhibitions, and cultural events. The building also has an exhibition hall showcasing theatre memorabilia. Visiting a performance here offers immersive insight into Pune’s vibrant performing arts scene. Even the surroundings—tree-lined streets, street cafés—echo local life and artistry."
  },
  {
    "title": "Vishrambaug Wada & Lal Mahal",
    "description": "Vishrambaug Wada and Lal Mahal are heritage mansions hidden within Pune’s wadas (old quarters). Wadas were traditional townhouses of Maratha nobility. Vishrambaug Wada still has intricately carved wooden balconies, internal courtyards, and a sense of the bygone era. Near it lies Lal Mahal, once home to Shivaji Maharaj as a young prince. Though much of Lal Mahal is reconstructed, it houses a small museum and replicates Maratha-era life. Exploring these gives you a walking-tour feel of old Pune’s lanes, stories, and royal past."
  }
],

        "services": [
    {
      "name": "Goa to Pune Cab Service",
      "description": "Travel comfortably and safely from Goa to Pune with Meghana Cab’s trusted cab service. Our fleet consists of well-maintained vehicles including sedans, SUVs, and premium Innova Crysta, all driven by experienced drivers who know the routes thoroughly. Whether you are traveling for business, leisure, or family visits, enjoy timely pickups, door-to-door service, and hassle-free travel. Our competitive pricing and easy online booking make your journey from Goa to Pune smooth and stress-free."
    },
    {
      "name": "Goa to Pune One Way Cab",
      "description": "Looking for a convenient one-way cab from Goa to Pune? Meghana Cab offers flexible one-way taxi services tailored to your travel schedule. Ideal for travelers who want point-to-point service without a return trip, our one-way cabs come with transparent pricing and a variety of vehicle options including hatchbacks, sedans, and SUVs. Book in advance to secure a comfortable and safe ride from Goa to Pune."
    },
    {
      "name": "Goa to Pune Taxi",
      "description": "Experience reliable taxi services from Goa to Pune with Meghana Cab. Our taxi fleet is equipped with air conditioning and ample space, perfect for solo travelers, families, and corporate passengers. Professional chauffeurs ensure a safe and pleasant journey, while our customer support team is available 24/7 to assist you. Whether you require a quick transfer or a leisurely trip, we have taxi options that suit your needs."
    },
    {
      "name": "Goa to Pune Cab Price",
      "description": "Get transparent and affordable cab prices for your Goa to Pune trip with Meghana Cab. Our pricing depends on the vehicle type, distance, and trip duration, with no hidden charges. Whether you choose a budget-friendly sedan or a premium Innova Crysta, we guarantee competitive rates that offer great value for money. Contact us for customized fare quotes and special packages tailored to your travel plans."
    },
    {
      "name": "Goa to Pune Car Rental",
      "description": "Rent a car from Goa to Pune with Meghana Cab and enjoy the freedom to travel at your own pace. Our rental options include sedans, SUVs, and luxury cars like Innova Crysta and Ertiga, all maintained for safety and comfort. Whether you prefer self-drive or chauffeur-driven options, our rental services cater to all types of travelers. Explore Goa, Pune, and the surrounding areas with flexibility and convenience."
    },
    {
      "name": "Goa to Pune Innova Crysta Rental",
      "description": "Travel luxuriously from Goa to Pune with Meghana Cab’s Innova Crysta rental service. The Innova Crysta is ideal for families, groups, and corporate travelers seeking spacious seating, premium comfort, and advanced safety features. Our experienced drivers ensure a smooth and enjoyable ride across scenic routes. Choose our Innova Crysta rental for a premium travel experience from Goa to Pune."
    },
    {
      "name": "Goa to Pune Airport Cab",
      "description": "Arrive or depart smoothly with Meghana Cab’s Goa to Pune airport cab service. Our punctual and professional drivers monitor flight schedules to ensure timely pickups and drop-offs. Travel comfortably in our clean and well-maintained vehicles including sedans and SUVs. Whether you’re catching a flight or returning home, rely on Meghana Cab for a stress-free airport transfer from Goa to Pune."
    },
    {
      "name": "Goa to Pimpri Chinchwad Cab",
      "description": "Book a convenient and reliable cab service from Goa to Pimpri Chinchwad with Meghana Cab. Perfect for business travelers, students, and families, our vehicles provide comfortable seating and air conditioning. Enjoy door-to-door service, experienced drivers, and competitive pricing. We cater to all travel needs, ensuring a smooth journey between Goa and Pimpri Chinchwad."
    },
    {
      "name": "Goa to Pune Sedan Cab Booking",
      "description": "Book a stylish and comfortable sedan cab from Goa to Pune with Meghana Cab. Ideal for solo travelers and small groups, our sedans offer excellent fuel efficiency and smooth rides. Enjoy air-conditioned comfort, professional drivers, and reliable service with easy online booking. Perfect for business trips or personal travel, our sedan cabs guarantee a pleasant and affordable journey."
    },
    {
      "name": "Goa to Pune Ertiga Cab Service",
      "description": "Travel comfortably with family or friends from Goa to Pune in our spacious Ertiga cabs. Meghana Cab’s Ertiga service combines affordability with ample space, making it a popular choice for group travel. Equipped with AC and modern amenities, our Ertiga cabs ensure a relaxing trip. Book your Goa to Pune Ertiga cab today and enjoy a convenient and economical travel option."
    }
  ],
  "tableData": [
    ["Goa to Pune Cab Service", "Goa to Pune One Way Cab"],
    ["Goa to Pune Taxi", "Goa to Pune Cab Price"],
    ["Goa to Pune Car Rental", "Goa to Pune Innova Crysta Rental"],
    ["Goa to Pune Airport Cab", "Goa to Pimpri Chinchwad Cab"],
    ["Goa to Pune Sedan Cab Booking", "Goa to Pune Ertiga Cab Service"]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Goa to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab provides comfortable and dependable cab services from Goa to Pune, ensuring a smooth and hassle-free return journey."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop in Pune",
        "WhyChoosedescription": "We guarantee punctual pick-ups from Goa and timely drop-offs at any Pune destination, so your travel plans stay on schedule."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Goa-Pune Route",
        "WhyChoosedescription": "Our skilled drivers know the Goa to Pune route well, prioritizing safety, comfort, and efficient travel for a pleasant ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy budget-friendly Goa to Pune cab fares with Meghana Cab’s clear pricing and no hidden charges, making your trip economical and stress-free."
    },
    {
        "WhyChooseheading": "Sanitized and Safe Vehicles",
        "WhyChoosedescription": "Travel confidently in our sanitized cabs equipped with essential safety features such as GPS tracking, seat belts, and emergency support."
    },
    {
        "WhyChooseheading": "24/7 Availability for Goa to Pune Travel",
        "WhyChoosedescription": "Whether you require an early morning ride or a late-night service, Meghana Cab operates round the clock to meet your Goa to Pune travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Choose from one-way, round-trip, or customizable packages to suit your Goa to Pune journey preferences."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Support",
        "WhyChoosedescription": "Book your Goa to Pune cab effortlessly via our website or app. Our customer support team is always ready to assist you with any travel queries."
    }
]























    }



const faqData = [
    {
        question: "How can I book a Goa to Pune cab with Meghana Cab?",
        answer: "You can book a Goa to Pune cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Goa to Pune?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Goa to Pune trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Goa to Pune?",
        answer: "Yes, we offer both one-way and round-trip cab services from Goa to Pune and nearby locations."
    },
    {
        question: "How long does it take to travel from Goa to Pune by cab?",
        answer: "The journey typically takes around 9 to 12 hours, depending on traffic and the chosen route."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Goa to Pune?",
        answer: "Tolls, state taxes, and parking charges are additional and clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for long-distance travel like Goa to Pune?",
        answer: "Yes, our drivers are professional, experienced, and familiar with long-distance routes including Goa to Pune."
    },
    {
        question: "Can I request breaks or custom stops during the Goa to Pune journey?",
        answer: "Yes, you can request halts or breaks during the trip. Please inform us while booking."
    },
    {
        question: "Is the cab service from Goa to Pune available at night?",
        answer: "Yes, Meghana Cab offers 24/7 service, so you can book a cab for day or night travel as per your convenience."
    },
    {
        question: "What payment options are accepted for Goa to Pune cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Goa to Pune cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Deepak Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Traveling from Goa to Pune with Meghana Cab was very comfortable and safe. The driver was professional and the vehicle was well-maintained.”',
    },
    {
        name: 'Mrs. Kavita More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service by Meghana Cab for Goa to Pune trip. On-time pickup and friendly driver made the journey pleasant.”',
    },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa to Pune Cabs",
  "description": "Travel comfortably from Goa to Pune with Meghana Cabs. Offering reliable one-way cab service, affordable fares, and premium vehicles including Innova Crysta, Ertiga, and Sedans. Book your Goa to Pune taxi online for a safe and pleasant journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5127"
  }
};






    return (
        <div>


<Helmet>
  <title>Goa to Pune Cabs | One Way Taxi & Car Rental @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Goa to Pune cab service with Meghana Cabs. Affordable one-way taxis, car rentals, and premium vehicles like Innova Crysta and Ertiga. Safe, comfortable, and reliable travel experience."
  />
  <meta
    name="keywords"
    content="Goa to Pune Cab Service, goa to pune one way cab, goa to pune taxi, goa to pune cab price, goa pune cab service, goa to pune cab charges, goa to pune car rental, goa to pune taxi fare, goa to pune innova crysta, goa to pune innova cab service, Goa to Pune Innova Cabs, goa to pune cab booking, goa to pimpri chinchwad cab, goa to pune airport cab, goa to pune cab charges, goa to pune cab ertiga, goa to pune cab service, goa to pune sedan cab booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Goatopunecabs;